import React from 'react'
import {
    Box,
    HStack,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {BRAND_KEY} from '../../../brand'

//ICONS
import {InfoIcon, CloseIcon} from '../../../components/icons'

const CartShipping = ({onClose}) => {
    const style = useMultiStyleConfig('Cart', {})
    const {shipping} = style
    const {formatMessage} = useIntl()

    const isBrandBraun = BRAND_KEY === 'braun'

    const cartLabel = isBrandBraun ? (
        <FormattedMessage
            id="cart_default.cart_shipping.message.braun"
            defaultMessage="Shipping Message"
        />
    ) : (
        <FormattedMessage
            id="cart_default.cart_shipping.message"
            defaultMessage="Free shipping for orders over 30€"
        />
    )

    const handleClose = () => {
        onClose()
    }
    return (
        <Box {...shipping?.shippingContainer}>
            <HStack {...shipping?.shippingContent}>
                <InfoIcon {...shipping?.shippingIcon} />
                <Text {...shipping?.shippingText}>{cartLabel}</Text>
            </HStack>
            <Box>
                <CloseIcon
                    onClick={handleClose}
                    {...shipping?.closeIcon}
                    role="button"
                    aria-label={formatMessage({
                        id: 'cart_shipping.button.close.label',
                        defaultMessage: 'Close shipping information',
                    })}
                    tabIndex={0}
                />
            </Box>
        </Box>
    )
}

export default CartShipping

CartShipping.propTypes = {
    onClose: PropTypes.func.isRequired,
}
